import { Alert, AlertTitle, useTheme } from "@mui/material";
import { Info } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

export const AccidentInsuranceNotice: FC = () => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Alert
			variant="notice"
			severity="warning"
			icon={
				<IconBox bg={theme.palette.amber[100]} size={32}>
					<Info size={theme.iconSize.sm} color={theme.palette.amber[600]} />
				</IconBox>
			}
			sx={{ mx: theme.spacingTokens.lg, mt: theme.spacingTokens.lg }}
		>
			<AlertTitle>
				{t(Resources.Portfolio.AddNonLifeInsurance.AccidentNotice.title)}
			</AlertTitle>
			{t(Resources.Portfolio.AddNonLifeInsurance.AccidentNotice.description)}
		</Alert>
	);
};
